import { Container } from "@mui/system";
import React, { useEffect, useState } from "react";
import MiniDrawer from "../../Component/newNavBarCM/newNavBar";
import { Grid, Box, TextField, createTheme,useTheme, ThemeProvider } from "@mui/material";
import "./SharedFolder.Styles.css";
import { useSelector, useDispatch } from "react-redux";
import { fetchDocumentsForGDRIVE, fetchFrequecyForGDRIVE } from "../../API/api";
import { Actions } from "../../Action";
import { bindActionCreators } from "redux";
import CachedIcon from '@mui/icons-material/Cached';
import TableComponentForShared from "./TableComponentForShared";
import CircularProgress from '@mui/material/CircularProgress';
import { submitSourceDocsForCM } from "../../API/api";
import MuiAlert from '@mui/material/Alert';
import { Tooltip } from "@mui/material";
import { handleError } from "../../utils";
import VizButton from "../../Component/VizButtons/VizButton";
import { toast } from "react-toastify";
import VizParagraph from "../../Component/VizParagraph/VizParagraph";
import VizHeader from "../../Component/VizHeader/VizHeader";
import Layout from '../../NewComponent/LayoutCM/Layout';


const customTheme = (outerTheme) => createTheme({
	palette: {
		mode: outerTheme.palette.mode,
	},
	components: {
		MuiTextField: {
			styleOverrides: {
				root: {
					'& label.Mui-focused': {
						color: 'red',
					},
				}
			}
		}
	}
})

export default function SharedFolders() {
	const sharedFolderData = useSelector((state) => state.sharedFolderCMReducer);
	const dispatch = useDispatch();
	const { getgdriveFrequecyData, getgdriveDocumentsData, isLoadingSharedCMData } = bindActionCreators(Actions, dispatch)
	/* State methods for submit form shared folder start */
	const [formLink, setFormLink] = useState('');
	const [folderName, setFolderName] = useState('');
	const [getFrequencyValue, setFrequencyValue] = useState('Select Frequency');
	const [error, setError] = useState(false);
	const [errorFolderLink, setFolderLink] = useState(false);
	const outerTheme = useTheme();


	const onChangeFormLink = (e) => {
		const regex = new RegExp('(docs.google.com|(http|https))(://[A-Za-z])');
		setFormLink(e.target.value)
		regex.test(e.target.value);
		if (!e.target.value.includes('/folders')) {
			setFolderLink(true);
		}
		else {
			setFolderLink(false)
		}
	}

	const checkIfUrl = (val) => {
		const regex = new RegExp('(https?://drive.google)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?');
		return regex.test(val);
	}
	const onChangeFolderName = (e) => {
		setFolderName(e.target.value)
		validateFileName(e.target.value);
	}

	function validateFileName(val) {
		var re = /^([a-zA-Z0-9][^*/><?\|:]*)$/;
		if (re.test(val) === false) {
			// alert("Error: Input contains invalid characters!");
			// $('#new_folder_name').focus();
			setError(true);
		}
		else {
			setError(false)
		}
	}

	const onChangeFrequencyValue = (e) => {
		setFrequencyValue(e.target.value);
	}
	/* State methods for submit form shared folder end */

	useEffect(() => {
		isLoadingSharedCMData(true);
		fetchFrequecyForGDRIVE().then((res) => {
			if (res===undefined) return;
			if (res.data.data !== undefined || res.data.success) {
				getgdriveFrequecyData(res.data.data);
			}
		})
		fetchDocumentsForGDRIVE().then((res) => {
			if (res===undefined) return;
			if (res.data.data !== undefined || res.data.success) {

				getgdriveDocumentsData(res.data.data);
				isLoadingSharedCMData(false)
			}
		})
	}, [])

	// const Alert = React.forwardRef(function Alert(props, ref) {
	// 	return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
	// });

	const submitSuccessToast = () => {
		return (
			<>
				<span style={{ fontSize: "12px" }}>
					Request is being processed in the background.
				</span>
			</>
		);
	};

	const onSubmitDocs = () => {
		isLoadingSharedCMData(true)
		let payload = {
			folderName: folderName,
			folderUrl: formLink,
			frequency: Number(getFrequencyValue)
		}
		submitSourceDocsForCM(payload).then((res) => {
			if (res===undefined) return;
			isLoadingSharedCMData(false)
			if (res.data.data !== undefined || res.data.success) {
				toast.success(submitSuccessToast(), {
					position: toast.POSITION.TOP_RIGHT
				})
				isLoadingSharedCMData(true)
				fetchDocumentsForGDRIVE().then((res) => {
					if (res===undefined) return;
					if (res.data.data !== undefined || res.data.success) {
						getgdriveDocumentsData(res.data.data);
						isLoadingSharedCMData(false)
					}
				})
			}
		}).catch((err) => handleError(err))
	}

	const onClickRefresh = () => {
		isLoadingSharedCMData(true)
		fetchDocumentsForGDRIVE().then((res) => {
			if (res===undefined) return;
			if (res.data.data !== undefined || res.data.success) {
				getgdriveDocumentsData(res.data.data);
				isLoadingSharedCMData(false);
			}
		})
	}
	return (
		<>
			<Layout>
				<Container>
					<Box paddingTop={5}>
					</Box>
					<Grid container={true} xs={12} sm={12} >
						<Grid item xs={12} sm={12}>
							<Box padding={3}>
								<Grid item xs={12}>
									<Box padding={2} border="border: 1px solid #eee" borderRadius="6px" boxShadow="7px 7px 20px lightgrey" sx={{ backgroundColor: '#fff' }}>
										<h3 style={{textAlign:'left'}}>
										<VizHeader type={4}>Upload Shared Folders</VizHeader></h3>
										<Grid container={true}>
											<Grid item xs={2} justifyContent="flex-end">
												<Box sx={{display:'flex',justifyContent:'flex-end',padding:'5px'}}>
												<VizParagraph type={5}>
												<label>Folder Name:</label>
												</VizParagraph>
												</Box>
											</Grid>
											<Grid item xs={8}>
											<ThemeProvider theme={customTheme(outerTheme)}>
												<TextField FormHelperTextProps={{
													style:{
														marginLeft:0,
														outline:'none'
													}
												}} 		sx={{
													"& .fieldset":{
														border:'none'
													}
												}} autoComplete="off" error={error && folderName.length > 0 ? true : false} helperText={folderName.length > 0 && error && "Invalid Folder Name"} type="text" value={folderName} onChange={(e) => onChangeFolderName(e)} inputProps={{ style: { padding: 5, outline: 'none', fontSize: '14px' } }} fullWidth id="fullWidth" />
											</ThemeProvider>
											</Grid>
											<Grid item xs={2}>
											</Grid>
										</Grid>
										<Grid container={true} pt={2}>
											<Grid item xs={2}>
											<Box sx={{display:'flex',justifyContent:'flex-end',padding:'5px'}}>
											<VizParagraph type={5}>
												<label>Folder Link:</label>
												</VizParagraph>
												</Box>
											</Grid>
											<Grid item xs={8}>
												<TextField FormHelperTextProps={{style:{marginLeft:0}}} autoComplete="off" error={errorFolderLink && formLink.length > 0 ? true : false} type="url" helperText={errorFolderLink && formLink.length > 0 && "Invalid URL Link"} value={formLink} onChange={(e) => onChangeFormLink(e)} inputProps={{ style: { padding: 5, fontSize: '14px' } }} fullWidth id="fullWidth" />
											</Grid>
											<Grid item xs={2}>

											</Grid>
										</Grid>
										<Grid container={true} pt={2}>
											<Grid item xs={2}>
												<Box sx={{display:'flex',justifyContent:'flex-end',padding:'5px'}}>
													<VizParagraph type={5}>
												<label>Update Frequency:</label>
												</VizParagraph>
												</Box>
											</Grid>
											<Grid item xs={8}>
												<select style={{textTransform:'capitalize',width:'19%',borderRadius:'6px',border:'1px solid lightgrey'}} defaultValue={getFrequencyValue} value={getFrequencyValue} onChange={(e) => onChangeFrequencyValue(e)} placeholder="Select Frequency" className="sharedFolderSelect">
													<option value="Select Frequency">Select Frequency</option>
													{
														sharedFolderData.frequency.length > 0 &&
														sharedFolderData.frequency.map((data, index) => {
															return (
																<>
																	<option  value={data.id} key={index}>{data.name}</option>
																</>
															)
														})
													}
												</select>
											</Grid>
											<Grid item xs={2}>
											</Grid>
										</Grid>
										<Grid container={true} pt={2} justifyContent="flex-end">
											<Grid item xs={2}>
											</Grid>
											<Grid item xs={8}>
											<Box display="flex" justifyContent="flex-end">
												{/* <button disabled=
												{(formLink === '' || folderName === '' || error === true || errorFolderLink === true || getFrequencyValue === 'Select Frequency') 
												? true : false} className="submitButtonSharedFolder" onClick={() => onSubmitDocs()}>Submit</button> */}
												{
													(formLink === '' || folderName === '' || error === true || errorFolderLink === true || getFrequencyValue === 'Select Frequency')
														?
														<VizButton type={"Disabled"} size={3}>Submit</VizButton>
														:
														<VizButton type={"Primary"} size={3} onClick={onSubmitDocs}>Submit</VizButton>
												}
												</Box>
											</Grid>
											<Grid item xs={2}>
												
											</Grid>
										</Grid>
									</Box>
								</Grid>
								<Grid xs={12} sm={12} container={true} pt={3}>
									<Grid item xs={12}>
										<Box padding={2} boxShadow="7px 7px 20px lightgrey" sx={{ borderRadius:'6px', backgroundColor: '#fff', width: '100%' }}>
											<Box paddingBottom={1} alignItems="baseline" display="flex" justifyContent="space-between">
												<h3>
												<VizHeader type={4}>
													Folder List
													</VizHeader>
												</h3>
												<button className="refreshRecords" onClick={() => onClickRefresh()}>
													<Tooltip title="Refresh List">
														<CachedIcon sx={{ color: 'var(--questionText_color)' }} />
													</Tooltip>
												</button>
											</Box>
											{sharedFolderData.isLoading === true && <Box sx={{ display: 'flex', justifyContent: 'center' }}>
												<CircularProgress />
											</Box>
											}
											{sharedFolderData.isLoading === false && <TableComponentForShared />}
										</Box>
									</Grid>
								</Grid>
							</Box>
						</Grid>
					</Grid>
				</Container>
			</Layout>
		</>
	)
}